import { Base64 } from 'js-base64';
import * as type from './type-utils';

/**
 * 空函数, 用于默认赋值
 */
export function noop() { }

/**
 * 延迟, 用于 async await 等待
 * 用例:
 * (async ()=>{
 *   console.log('等待1s');
 *   await delay(1000);
 *   console.log('完成');
 * })();
 * @param ms
 */
export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * 移除空白spaces
 * 输入: 137 2700 3240
 * 输出: 13727003240
 * @param text
 * @return {*}
 */
export function removeSpaces(text) {
  if (!text) {
    return text;
  }
  return text.replace(/\D+/g, '');
}

/**
 * 创建数组分组
 * @example
 * var arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
 * var groupedArr = createGroupedArray(arr, 4);
 * var result = JSON.stringify(groupedArr);
 * // result: "[[1,2,3,4],[5,6,7,8],[9,10,11,12],[13,14]]"
 * @return {Array}
 */
export function createGroupedArray(arr, chunkSize) {
  let groups = [],
    i = 0,
    arrLength = arr.length;
  for (; i < arrLength; i += chunkSize) {
    groups.push(arr.slice(i, i + chunkSize));
  }
  return groups;
}

/**
 * 仿 C# String.Format 实现
 * @example
 * 输入: stringFormat('{0} is dead, but {1} is alive!', 'ASP', 'ASP.NET');
 * 输出: ASP is dead, but ASP.NET is alive!
 * @param format
 * @return {*}
 */
export function stringFormat(format) {
  const args = Array.prototype.slice.call(arguments, 1);
  return format.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] !== 'undefined' ? args[number] : match;
  });
}

/**
 * 对象转换成 json string
 * @param input
 * @return {*}
 */
function object2JSONString(input) {
  if (!type.isNullOrUndefined(input)) {
    let str = input;
    if (type.isObjectLike(str)) {
      str = JSON.stringify(str);
    }
    if (type.isString(str)) {
      return str;
    }
  }
  throw new Error('the type of input should be {object} or {string}');
}

/**
 * base 64 url 编码
 * @param input
 */
export function base64UrlEncode(input) {
  const str = object2JSONString(input);
  return Base64.toBase64(str, true);
}

/**
 * base 64 url 解码
 * @param str
 * @param jsonParse
 * @return {*}
 */
export function base64UrlDecode(str, jsonParse = true) {
  const result = Base64.fromBase64(str);
  if (jsonParse) {
    return JSON.parse(result);
  }
  return result;
}

export function getParameterByNames(name, url) {
  // eslint-disable-next-line no-undef
  if (!url) url = window.location.href;
  name = name.replace(/[[]]/g, '$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function convertPxToRem(content) {
  if (!content) return content;
  // return content;
  const baseSize = 42; // 与SCSS保持一致

  // 转换各种CSS属性的px单位为rem
  let convertedContent = content
    // 转换font-size
    .replace(/font-size:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换字体大小: ${px}px → ${remValue}rem`);
      return `font-size: ${remValue}rem`;
    })
    // 转换line-height (如果是px单位)
    .replace(/line-height:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换行高: ${px}px → ${remValue}rem`);
      return `line-height: ${remValue}rem`;
    })
    // 转换margin
    .replace(/margin:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换外边距: ${px}px → ${remValue}rem`);
      return `margin: ${remValue}rem`;
    })
    // 转换padding
    .replace(/padding:\s*(\d+(?:\.\d+)?)px/g, (match, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换内边距: ${px}px → ${remValue}rem`);
      return `padding: ${remValue}rem`;
    })
    // 转换margin-top, margin-bottom等
    .replace(/margin-(top|bottom|left|right):\s*(\d+(?:\.\d+)?)px/g, (match, direction, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换${direction}外边距: ${px}px → ${remValue}rem`);
      return `margin-${direction}: ${remValue}rem`;
    })
    // 转换padding-top, padding-bottom等
    .replace(/padding-(top|bottom|left|right):\s*(\d+(?:\.\d+)?)px/g, (match, direction, px) => {
      const remValue = parseFloat(px) / baseSize;
      // console.log(`转换${direction}内边距: ${px}px → ${remValue}rem`);
      return `padding-${direction}: ${remValue}rem`;
    });

  return convertedContent;
}

/**
 * 模拟a标签跳转
 * @param url
 * @param target
 * @return {*}
 */
export function aLink(url, target = '_blank', isShort) {
  const isMas = DEPLOY_ENV === 'master';
  const a = document.createElement('a');
  a.href = url;
  a.target = target;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
